import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CmsService } from 'src/app/services/api/cms.service';
import { WinService } from 'src/app/services/win.service';

@Component({
	selector: 'app-page-notfound',
	templateUrl: './page-notfound.component.html',
	styleUrls: ['./page-notfound.component.scss']
})
export class PageNotfoundComponent implements OnInit {

	page:any = null;

	constructor(
		public router: Router,
		public winService: WinService,
		public cms: CmsService,
		public title: Title
	) { }

	ngOnInit() {
		this.cms.getPage(17, true, false).then(page => {
			this.page = page;
			this.title.setTitle(this.page.meta_title);
		});
		// this.router.navigate(['/']); 
	}

}
